/* eslint-disable-next-line no-restricted-imports */
import type { StoreSpecial } from '@jane/shared/models';
import { getActualUnitPrice, getUnitPrice } from '@jane/shared/util';

import type { CartDrawerCardProduct } from './cartDrawerCard';
import { CartDrawerCard } from './cartDrawerCard';

/** What the card reads, plus the one field this component reads itself. */
type CartDrawerItemProduct = CartDrawerCardProduct & {
  special_id?: number | string | null;
};

interface CartDrawerItemsProps {
  bloomUserExperience?: boolean;
  headless?: boolean;
  product: CartDrawerItemProduct;
  productDetailLink: string;
  specials: StoreSpecial[];
  storeId?: string | number;
}

export const CartDrawerItem = ({
  headless,
  product,
  productDetailLink,
  specials,
  storeId,
  bloomUserExperience,
}: CartDrawerItemsProps) => {
  const applicableSpecial = specials?.find(
    (special: StoreSpecial) => product.special_id === special.id
  );

  const productPrice = getActualUnitPrice(
    product,
    product.price_id,
    applicableSpecial
  ) as number;

  const productFullPrice = getUnitPrice(product, product.price_id);

  return (
    <CartDrawerCard
      bloomUserExperience={bloomUserExperience}
      headless={headless}
      productPrice={productPrice}
      product={product}
      productDetailLink={productDetailLink}
      productFullPrice={productFullPrice!}
      storeId={storeId}
    />
  );
};
